import React from 'react';
import {Field} from 'react-final-form';
import {compose} from 'recompose';
import {FormFieldCheckbox} from '@yandex-data-ui/cloud-components';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import withFinalForm, {WithFinalForm} from 'hoc/withFinalForm';
import TrafficField from 'components/calculator/Traffic/TrafficField/TrafficField';
import {GreenplumFormValues} from 'components/calculator/GreenplumForm/GreenplumForm';
import GreenplumHostForm, {
    GreenplumHostFormRef,
} from 'components/calculator/GreenplumForm/GreenplumHostForm/GreenplumFormItemHost';
import {GreenplumPreparedConfig} from 'components/calculator/GreenplumForm/utils';

export enum HostTypeFiled {
    MASTER = 'master',
    SEGMENT = 'segment',
}

interface GreenplumFormItemHostValues {
    platform: string;
    disk: string;
    size: number;
    presetId: string;
    hosts: number;
    type: string;
}

export interface GreenplumFormItemValues {
    master: GreenplumFormItemHostValues;
    segment: GreenplumFormItemHostValues;
    ip: boolean;
    traffic: number;
}

interface GreenplumFormItemOwnProps {
    index: number;
    data: {
        master: GreenplumPreparedConfig;
        segment: GreenplumPreparedConfig;
    };
    name: string;
    values: GreenplumFormItemValues;
}

type GreenplumFormItemProps = GreenplumFormItemOwnProps &
    WithTranslationProps &
    WithFinalForm<GreenplumFormValues>;

const GreenplumFormItem: React.FC<GreenplumFormItemProps> = (props) => {
    const {index, values, data, name, i18nK} = props;

    const segmentRef = React.useRef<GreenplumHostFormRef | null>(null);
    const onPlatformChange = (platform: string) => {
        segmentRef.current?.sync(platform);
    };

    if (!values) {
        return null;
    }

    return (
        <React.Fragment>
            {[HostTypeFiled.MASTER, HostTypeFiled.SEGMENT].map((hostType) => {
                return (
                    <GreenplumHostForm
                        key={hostType}
                        forwardRef={hostType === HostTypeFiled.SEGMENT ? segmentRef : undefined}
                        onPlatformChange={
                            hostType === HostTypeFiled.MASTER ? onPlatformChange : undefined
                        }
                        hostType={hostType}
                        data={data[hostType]}
                        values={values[hostType]}
                        index={index}
                        name={name}
                    />
                );
            })}
            <CalculatorFormLayout.Row title={i18nK('field_mdb-ip')} note={i18nK('context_mdb-ip')}>
                <Field name={`${name}.ip`}>
                    {(fieldProps) => <FormFieldCheckbox {...fieldProps} size="l" />}
                </Field>
            </CalculatorFormLayout.Row>
            <TrafficField name={`${name}.traffic`} />
        </React.Fragment>
    );
};

export default compose<GreenplumFormItemProps, GreenplumFormItemOwnProps>(
    withFinalForm<GreenplumFormValues>(),
    withTranslation('calculator'),
)(GreenplumFormItem);
